import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import socketService from './services/socket';
import { SesionProvider } from './context/SesionContext';
import './App.css';

// Páginas
import Home from './pages/Home';
import CreateGame from './pages/CreateGame';
import JoinGame from './pages/JoinGame';
import WaitingRoom from './pages/WaitingRoom';
import Game from './pages/Game';
import Results from './pages/Results';
import AdminCampos from './pages/AdminCampos';
import Cuenta from './pages/Cuenta';
import MisPartidas from './pages/MisPartidas';

function App() {
  useEffect(() => {
    // Conectar socket al montar la aplicación
    socketService.connect();

    // Desconectar al desmontar
    return () => {
      socketService.disconnect();
    };
  }, []);

  return (
    <SesionProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/crear" element={<CreateGame />} />
            <Route path="/unirse/:codigo?" element={<JoinGame />} />
            <Route path="/sala/:codigo" element={<WaitingRoom />} />
            <Route path="/juego/:codigo" element={<Game />} />
            <Route path="/resultados/:codigo" element={<Results />} />
            <Route path="/admin/campos" element={<AdminCampos />} />
            <Route path="/cuenta" element={<Cuenta />} />
            <Route path="/mis-partidas" element={<MisPartidas />} />
          </Routes>
        </div>
      </Router>
    </SesionProvider>
  );
}

export default App;
